var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36514 4.23441C9.51512 4.38443 9.59937 4.58788 9.59937 4.80001C9.59937 5.01214 9.51512 5.21559 9.36514 5.36561L6.73074 8.00001L9.36514 10.6344C9.44155 10.7082 9.5025 10.7965 9.54443 10.8941C9.58635 10.9917 9.60842 11.0967 9.60934 11.2029C9.61027 11.3091 9.59003 11.4145 9.5498 11.5128C9.50958 11.6111 9.45017 11.7004 9.37506 11.7755C9.29995 11.8506 9.21062 11.91 9.11231 11.9503C9.01399 11.9905 8.90865 12.0107 8.80242 12.0098C8.6962 12.0089 8.59122 11.9868 8.49362 11.9449C8.39602 11.903 8.30774 11.842 8.23394 11.7656L5.03394 8.56561C4.88396 8.41559 4.79971 8.21214 4.79971 8.00001C4.79971 7.78788 4.88396 7.58443 5.03394 7.43441L8.23394 4.23441C8.38397 4.08444 8.58741 4.00018 8.79954 4.00018C9.01168 4.00018 9.21512 4.08444 9.36514 4.23441Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNav);
export default __webpack_public_path__ + "static/media/arrow-nav.234c2ac13730bee0ed358f12cfcc29ce.svg";
export { ForwardRef as ReactComponent };